<template>
  <theme-provider>
    <v-app>
      <suspense>
        <router-view />
      </suspense>
      <update-notification />
    </v-app>
  </theme-provider>
</template>

<script lang="ts">
  import { useHead } from '@unhead/vue';
  import { defineComponent } from 'vue';
  import { useRouter } from 'vue-router';
  import ThemeProvider from '@/components/theme-switch/ThemeProvider.vue';
  import UpdateNotification from '@/components/update-notification/UpdateNotification.vue';

  export default defineComponent({
    name: 'App',
    components: { ThemeProvider, UpdateNotification },
    setup() {
      const router = useRouter();
      useHead({
        title: () => {
          return String(router.currentRoute.value.meta['title']);
        },
      });
      return {};
    },
  });
</script>
